<template>
	<div :class="`w-full flex bg-${color}-100 border border-${color}-300 mb-4 rounded-md justify-between`">
		<p :class="`text-${color}-500 text-left p-2`">
			<slot></slot>
		</p>

		<rp-button
			v-if="!noClose"
			class="bg-opacity-0"
			:typoColor="`${color}-500`"
			:hoverColor="`${color}-100`"
			@click="$emit('close')"
		>
			<svg
				viewBox="0 0 20 20"
				fill="currentColor"
				class="x w-6 h-6"
			>
				<path
					fill-rule="evenodd"
					d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
					clip-rule="evenodd"
				></path>
			</svg>
		</rp-button>
	</div>
</template>

<script>
import RpButton from "../components/RpButton";

export default {
	name: "RpAlert",
	components: {
		RpButton
	},
	props: {
		level: {
			type: String,
			default: "success",
			validator: val => ["success", "error", "info", "alert"].includes(val)
		},
		noClose: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		color() {
			/* eslint-disable indent */
			switch (this.level) {
				case "success":
					return "green";
				case "error":
					return "red";
				case "info":
					return "blue";
				case "alert":
					return "yellow";
				default:
					return "green";
			}
		}
	}
};
</script>

<style>
</style>